import { useEffect, useState, useRef, useCallback } from 'react';
import queryString from 'query-string';
import Api from '../utils/api';

function useApi({ api = Api, path, query, defaultValue, serializer, retryIntervalOnConflict, options = {} }) {
  const [value, setValue] = useState(defaultValue);
  const [error, setError] = useState();
  const [complete, setComplete] = useState(false);
  const [loading, setLoading] = useState(false);
  
  const ref = useRef(true);
  const serializerRef = useRef(serializer);
  serializerRef.current = serializer;

  useEffect(() => {
    return () => {
      ref.current = false;
    }
  }, []);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const execute = useCallback((url = path) => {
    setComplete(false);
    setLoading(true);

    api.get(queryString.stringifyUrl({
      url: url,
      query: query
    }, options)).then(res => {
      // if (!ref.current) return;
      const s = serializerRef.current;
      setValue(typeof s === 'function' ? s(res) : res);
      setLoading(false);
      setComplete(true);
    }).catch(error => {
      // if (!ref.current) return;
      if (retryIntervalOnConflict && error?.status === 409) {
        setTimeout(() => execute(url), retryIntervalOnConflict);
      } else {
        setError(error);
        setLoading(false);
        setComplete(true);
      }
    });
  // JSON.stringify(query) mirrors the existing effect below — avoids object identity churn
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [path, JSON.stringify(query)]);

  useEffect(() => {
    if (!path) return;
    if (path) execute();
  }, [path, JSON.stringify(query)]);

  return { value, setValue, error, execute, loading, complete };
}

export default useApi;